(function () {
  const sizeGuideBtn = document.querySelector('.voo-size-chart');
  const sizeGuide = document.getElementById('voo-size-guide');
  const sizeGuideCloseBtn = sizeGuide.querySelector('.close__button');

  sizeGuide.addEventListener('click', (e) => {
    if (e.target.classList.contains('size-guide__overlay') || sizeGuideCloseBtn.contains(e.target)) {
      sizeGuide.classList.remove('opened');
      document.body.classList.remove('overflow-hidden');
    }
  });

  sizeGuideBtn.addEventListener('click', (e) => {
    e.preventDefault();
    sizeGuide.classList.add('opened');
    document.body.classList.add('overflow-hidden');
  });
})();
